<template>
  <a-button
    :type="typeBtnFilter"
    :ghost="ghostBtnFilter"
    :disabled="$attrs.disabled"
    @click="handleClickBtn"
  >
    <slot></slot>
  </a-button>
</template>

<script setup lang="ts">
import { computed } from "vue";

const model = defineModel<boolean | null>();

const typeBtnFilter = computed(() => {
  return model.value ? "primary" : "default";
});

const ghostBtnFilter = computed(() => {
  return model.value;
});

const handleClickBtn = () => {
  model.value = !model.value;
};
</script>

<style scoped lang="scss"></style>
